import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Ajuste na inicialização do estado
const getInitialState = () => {
  try {
    const savedEmpresa = localStorage.getItem('empresaLogada');
    // Verifica se existe e se é um JSON válido
    if (savedEmpresa) {
      JSON.parse(savedEmpresa); // Teste de parse para garantir formato válido
      return savedEmpresa;
    }
  } catch (error) {
    console.error('Erro ao carregar empresa do localStorage:', error);
    // Reseta para um valor padrão se houver erro
    localStorage.removeItem('empresaLogada');
  }
  return JSON.stringify({ id: null, nome: '' }); // Valor padrão
};

const initialState = getInitialState();

const empresaSlice = createSlice({
  name: 'empresaLogada',
  initialState,
  reducers: {
    setEmpresaLogada: (state, action: PayloadAction<string>) => {
      try {
        // Tenta validar se é um JSON válido antes de salvar
        JSON.parse(action.payload);
        localStorage.setItem('empresaLogada', action.payload);
        return action.payload;
      } catch (error) {
        console.error('Erro ao salvar empresa:', error);
        return state; // Mantém o estado atual se houver erro
      }
    },
    setNomeEmpresa: (state, action: PayloadAction<string>) => {
      localStorage.setItem('nomeEmpresa', action.payload);
      return state; // Para este reducer, não alteramos o state de empresaLogada
    }
  }
})

export const { setEmpresaLogada, setNomeEmpresa } = empresaSlice.actions;
export default empresaSlice.reducer